export default __webpack_public_path__ + "static/media/mail.eb45bac8.svg";